<div id="iframe-portalV1">
  <p-confirmPopup key="distributionListActivate">
    <ng-template pTemplate="content" let-message>
      <div class="flex flex-column align-items-center p-4"
           style="width: 36rem; max-width: 90vw; padding: 0 !important;">
        <div class="flex align-items-center justify-content-center mb-3" style="text-align: center">
          <i class="pi pi-exclamation-circle text-danger" style="font-size: 3rem;"></i>
        </div>
        <div class="w-full">
          <h4 class="mt-0 mb-3 text-center" style="font-size: 1.45rem; line-height: 1.35; font-weight: 600;">
            Convert this user to a distribution list?
          </h4>
          <ul class="m-0" style="padding-left: 1.25rem; line-height: 1.65; font-size: 1rem;">
            <li>The user will no longer be able to sign in to the customer portal.</li>
            <li>This account will no longer use a password.</li>
            <li>The email address will remain unchanged.</li>
            <li>API access will remain available for distribution lists.</li>
          </ul>
        </div>
      </div>
    </ng-template>
  </p-confirmPopup>
  <p-confirmPopup key="distributionListDeactivate">
    <ng-template pTemplate="content" let-message>
      <div class="flex flex-column align-items-center p-4"
           style="width: 36rem; max-width: 90vw; padding: 0 !important;">
        <div class="flex align-items-center justify-content-center mb-3" style="text-align: center">
          <i class="pi pi-exclamation-circle text-danger" style="font-size: 3rem;"></i>
        </div>
        <div class="w-full">
          <h4 class="mt-0 mb-3 text-center" style="font-size: 1.45rem; line-height: 1.35; font-weight: 600;">
            Convert this user to a standard user?
          </h4>
          <ul class="m-0" style="padding-left: 1.25rem; line-height: 1.65; font-size: 1rem;">
            <li>The user will be able to sign in to the customer portal.</li>
            <li>A password setup or reset will be required.</li>
            <li>The email address will remain the same.</li>
            <li>API access will continue as configured for standard users.</li>
          </ul>
        </div>
      </div>
    </ng-template>
  </p-confirmPopup>
  <p-confirmPopup key="regenerateApiKey">
    <ng-template pTemplate="content" let-message>
      <div class="flex flex-column align-items-center p-4"
           style="width: 26rem; max-width: 90vw; padding: 0 !important;">
        <div class="flex align-items-center justify-content-center mb-3" style="text-align: center">
          <i class="pi pi-exclamation-circle text-danger" style="font-size: 3rem;"></i>
        </div>
        <div class="w-full">
          <h4 class="mt-0 mb-0 text-center" style="font-size: 1.45rem; line-height: 1.35; font-weight: 600;">
            Regenerate this user's API key?
          </h4>
          <p class="mb-0 text-center" style="font-size: 1rem; line-height: 1.5;">
            The current key will stop working immediately. Any integration using it will need to be updated.
          </p>
        </div>
      </div>
    </ng-template>
  </p-confirmPopup>
  <p-dialog [(visible)]="displayHelpPopUp" header="Distribution Email (notifications and API access only)"
            dismissableMask="true"
            modal="true">
    <div>
      Enable this option for a shared mailbox or distribution list that won’t need to log in.
      <ul>
        <li>The address will receive notifications from us.</li>
        <li>It cannot be used to log in.</li>
        <li>It may be used to call McKay Portal's API.</li>
        <li>The only possible roles are Operations and/or Finance.</li>
        <li>This account will remain active until deactivated or deleted by an admin.</li>
      </ul>
    </div>
  </p-dialog>
  <nav class="navbar navbar-expand navbar-light bg-light mb-3" id="breadcrumb-sf-1">
    <nav aria-label="breadcrumb" class="navbar-nav mr-auto">
      <ng-container *ngIf="!loading; ">
        <ol class="breadcrumb ol-sf-1">
          <li class="breadcrumb-item">
            <a *roles="['ROLE_MCKAY']" routerLink="/mckay/{{getUserCurrent()?.company.uniqid}}">Home</a>
            <a *roles="['ROLE_CLIENT']" routerLink="/client/{{getUserCurrent()?.company.uniqid}}">Home</a>
          </li>
          <ng-container *ngIf="getUserCurrent()?.company.uniqid === 'admin'; else companyNotAdmin">
            <li class="breadcrumb-item">
              <a routerLink="/{{getUserCurrent()?.company.uniqid}}/company">List companies</a>
            </li>
            <li *ngIf="currentCompany" class="breadcrumb-item">
              <a
                routerLink="/{{getUserCurrent()?.company.uniqid}}/company/{{currentCompany?.uniqid}}/edit">{{ currentCompany?.name }}</a>
            </li>
            <li *ngIf="currentCompany" class="breadcrumb-item">
              <a
                routerLink="/{{getUserCurrent()?.company.uniqid}}/{{currentCompany?.uniqid}}/users">List users</a>
            </li>
          </ng-container>
          <ng-template #companyNotAdmin>
            <li *ngIf="currentCompany" class="breadcrumb-item">
              <a routerLink="/{{getUserCurrent()?.company.uniqid}}/{{currentCompany?.uniqid}}/users">List users</a>
            </li>
          </ng-template>
          <li *ngIf="isShowPage() || isEditPage()" aria-current="page" class="breadcrumb-item active">
            {{ currentUser?.name }}
          </li>
          <li *ngIf="isAddPage()" aria-current="page" class="breadcrumb-item active">
            Add user
          </li>
        </ol>
      </ng-container>
    </nav>

  </nav>
  <ng-container *ngIf="notAuthorized; else authorizedContent">
    <div>You don't have the required permission to access this page.</div>
  </ng-container>
  <ng-template #authorizedContent>
    <div class="container-fluid">
      <div *ngIf="!loading">
        <div *ngIf="error" class="alert alert-danger alert-dismissible fade show">
          {{ errorMessage }}
          <button (click)="error = false" aria-label="Close" class="close" type="button">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div *ngIf="expiredNdaError" class="alert alert-danger alert-dismissible fade show">
          Please renew your NDA before adding a contact with unidentified domain.
          <button (click)="expiredNdaError = false" aria-label="Close" class="close" type="button">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <ng-container *ngIf="userNotFound">
          <div class="alert alert-warning alert-dismissible fade show">
            User not found.
          </div>
          <div class="d-flex justify-content-end buttons-margin-left">
            <button *ngIf="currentCompany; else backButtonPlaceholder" class="btn btn-outline-primary"
                    routerLink="/{{getUserCurrent()?.company.uniqid}}/{{currentCompany?.uniqid}}/user" type="button">
              <i aria-hidden="true" class="fa fa-arrow-left pr-2"></i>
              Back to list
            </button>
            <ng-template #backButtonPlaceholder></ng-template>
          </div>
        </ng-container>
        <div *ngIf="!userNotFound && !accessDenied">
          <div class="pb-2 mb-3 border-bottom">
            <h3 *ngIf="isAddPage() && currentCompany"><b>Add {{ currentCompany?.name }} user</b></h3>
            <h3 *ngIf="(isShowPage() || isEditPage()) && currentUser"><b>{{ currentUser?.name }}</b></h3>
          </div>

          <div *ngIf="success && (isEditPage() || isAddPage()) || (isEditPage() && successEditEmail)"
               class="alert alert-success alert-dismissible fade show">
            <div *ngIf="success && (isEditPage() || isAddPage())">
              <span *ngIf="isEditPage()">The profile was updated successfully.</span>
              <span *ngIf="isAddPage() && isReceiveConfirmationEmails">A confirmation email has been sent to user. You can add one more user below.</span>
              <span *ngIf="isAddPage() && !isReceiveConfirmationEmails">User has been created. You can add one more user below.</span>
              <button (click)="success = false" aria-label="Close" class="close" type="button">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div *ngIf="isEditPage() && successEditEmail">
              We sent an email to your new email address with a confirmation link. Until you confirm your new address,
              you
              can continue using the old one.
              <button (click)="successEditEmail = false" aria-label="Close" class="close" type="button">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>
          <div *ngIf="successMessage != ''" class="alert alert-success alert-dismissible fade show">
            {{ successMessage }}
            <button (click)="successMessage = ''" aria-label="Close" class="close" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div *ngIf="successTransferSuperRole" class="alert alert-success info-text">
            <span>Super role was successfully transferred.</span>
          </div>
          <button (click)="showUnlockDialog()"
                  *ngIf="isEditPage() && !isUserToEditInSameCompanyAsLoggedInUser && !isEditModeConfirmed "
                  class="btn btn-outline-primary mb-3 mr-2"
                  data-placement="right"
                  data-toggle="tooltip"
                  title="By default, client information is not modifiable. To unlock, click on this button and enter your password."
                  type="button">
            <i aria-hidden="true" class="fa fa-lock pr-2"></i>
            Enable and confirm edit mode
          </button>
          <ng-container *ngIf="canConvertToDistributionList()">
            <button *ngIf="!currentUser?.isNotificationOnly" (click)="convertToDistributionList($event)"
                    class="btn btn-outline-danger mb-3" type="button" [disabled]="isLastUserForAtLeastOneRole">
              <i aria-hidden="true" class="fa fa-envelope pr-2"></i>
              Convert to distribution list
            </button>
            <button (click)="convertToStandardUser($event)" *ngIf="currentUser?.isNotificationOnly"
                    class="btn btn-outline-danger mb-3" type="button">
              <i aria-hidden="true" class="fa fa-user pr-2"></i>
              Convert to standard user
            </button>
          </ng-container>
          <form (ngSubmit)="onSubmit()" [formGroup]="registerForm">
            <div class="row">
              <div class="col-lg-6 col-md-12 pr-2">
                <section class="user-form-card">
                  <header class="user-form-card__header">
                    <span class="user-form-card__icon"><i class="fa fa-id-badge"></i></span>
                    <span>Account details</span>
                  </header>
                  <div class="user-form-card__body">
                    <div class="form-group" *ngIf="!isEditPage()">
                      <div class="custom-control custom-checkbox">
                        <input *ngIf="isAddPage()" class="custom-control-input" (change)="alterIsNotificationOnly()"
                               formControlName="isNotificationOnly" id="isNotificationOnly" type="checkbox">
                        <input *ngIf="isShowPage()" class="custom-control-input" [disabled]="true"
                               readonly formControlName="isNotificationOnly" id="isNotificationOnly" type="checkbox">
                        <label style="padding-top: 2px" class="custom-control-label" for="isNotificationOnly"
                               [pTooltip]="isEditPage() ? 'If you want to modify this user\'s account type, please delete it and recreate a standard user account.' : ''">
                          <b>This account email is a distribution list.
                            <i (click)="alterDisplayHelpPopUp()" class="fa fa-question-circle pull-right"
                               style="color: grey; cursor: pointer; position: absolute; padding-top: 4px"></i></b>
                          <br>
                          <small>Distribution Email (notifications and API access only)</small>
                        </label>
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="formGroupName">Name
                        <span *ngIf="submitted && registerFormControls.name.errors" class="alert required-items-alert">
                        is required
                      </span>
                      </label>
                      <div id="name_input">
                        <input [ngClass]="{ 'is-invalid': submitted && registerFormControls.name.errors }"
                               class="form-control" formControlName="name" id="formGroupName"
                               placeholder="Name"
                               type="text">
                      </div>
                    </div>

                    <div class="form-group mb-0">
                      <label for="formGroupEmail">Email
                        <span *ngIf="existingEmail || submitted && emailForm.errors" class="alert required-items-alert">
                        <label *ngIf="existingEmail">There is a user with this email address</label>
                        <label *ngIf="!existingEmail && emailForm.errors.required">is required</label>
                        <label *ngIf="!existingEmail && emailForm.errors.email">is invalid</label>
                      </span>
                      </label>
                      <div id="email_input">
                        <input [ngClass]="{ 'is-invalid': submitted && registerFormControls.email.errors }"
                               class="form-control" formControlName="email" id="formGroupEmail"
                               placeholder="Email"
                               type="text">
                      </div>
                    </div>
                  </div>
                </section>

                <section *ngIf="isClientCompany(currentCompany) && hasCompanyBillingAccount(currentCompany)"
                         class="user-form-card">
                  <header class="user-form-card__header">
                    <span class="user-form-card__icon"><i class="fa fa-building"></i></span>
                    <span>
                      <ng-container *ngIf="hasMultipleBusinessUnits">Business Units</ng-container>
                      <ng-container *ngIf="!hasMultipleBusinessUnits">Business Unit</ng-container>
                    </span>
                    <span *ngIf="!hasBillingAccount()" class="alert required-items-alert mb-0 ml-2">
                      At least one billing account is required
                    </span>
                  </header>
                  <div class="user-form-card__body">
                    <div [ngClass]="{ 'is-invalid': !hasBillingAccount() }">
                      <div *ngFor="let billingAccount of billingAccounts"
                           class="custom-control custom-checkbox custom-control">
                        <input [ngClass]="{ 'is-invalid': !hasBillingAccount() }" class="custom-control-input"
                               formControlName="{{billingAccount.formControlName}}"
                               id="{{billingAccount.id}}_enabled" type="checkbox">
                        <label class="custom-control-label"
                               for="{{billingAccount.id}}_enabled">{{ billingAccount.label }}</label>
                      </div>
                    </div>
                  </div>
                </section>

                <section class="user-form-card">
                  <header class="user-form-card__header">
                    <span class="user-form-card__icon"><i class="fa fa-phone"></i></span>
                    <span>Contact &amp; preferences</span>
                  </header>
                  <div class="user-form-card__body">
                    <div class="form-group">
                      <label>Daytime phone
                        <span *ngIf="submitted && !isValidDaytimePhone()" class="alert required-items-alert">
                        Digits only
                      </span>
                      </label>
                      <div class="input-group phone-input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">+</span>
                        </div>
                        <input [ngClass]="{ 'is-invalid error': submitted && !isValidDaytimePhoneCountryCode() }"
                               class="form-control phone-code-input" formControlName="daytimePhoneCountryCode"
                               id="daytime_phone_country_code_input"
                               name="daytimePhone" placeholder="Code"
                               type="text">
                        <input [ngClass]="{ 'is-invalid error': submitted && !isValidDaytimePhoneNationalNumber() }"
                               class="form-control"
                               formControlName="daytimePhoneNationalNumber" id="daytime_phone_national_number_input"
                               name="daytimePhone" placeholder="Phone number"
                               type="text">
                      </div>
                    </div>

                    <div class="form-group">
                      <label>Mobile phone
                        <span *ngIf="submitted && !isValidMobilePhone()"
                              class="alert required-items-alert">Digits only</span>
                      </label>
                      <div class="input-group phone-input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text">+</span>
                        </div>
                        <input [ngClass]="{ 'is-invalid error': submitted && !isValidMobilePhoneCountryCode() }"
                               class="form-control phone-code-input" formControlName="mobilePhoneCountryCode"
                               id="mobile_phone_country_code_input"
                               name="daytimePhone" placeholder="Code"
                               type="text">
                        <input [ngClass]="{ 'is-invalid error': submitted && !isValidMobilePhoneNationalNumber() }"
                               class="form-control"
                               formControlName="mobilePhoneNationalNumber"
                               id="mobile_phone_national_number_input"
                               name="daytimePhone" placeholder="Phone number"
                               type="text">
                      </div>
                    </div>

                    <hr *ngIf="isAddPage() || isEditPage()" class="user-form-card__divider">
                    <div *ngIf="isAddPage() || isEditPage()" class="form-group">
                      <div class="custom-control custom-checkbox">
                        <input *ngIf="isEditPage() && isEditMode || isAddPage()" class="custom-control-input"
                               formControlName="commercialOptIn"
                               id="commercialOptIn" type="checkbox">
                        <label *ngIf="isEditPage() && isEditMode || isAddPage()" class="custom-control-label"
                               for="commercialOptIn">
                          <b *ngIf="isAddPage()" style="color: #007bff"> I'd like to receive emails for items about
                            latency improvements, network upgrades, events and
                            press releases </b>
                          <b *ngIf="isEditMode && isEditPage()"> I'd like to receive emails for items about latency
                            improvements, network upgrades, events and
                            press releases </b>
                        </label>
                        <input *ngIf="isEditPage() && !isEditMode" class="custom-control-input"
                               disabled
                               formControlName="commercialOptIn" id="commercialOptInDisabled" type="checkbox">
                        <label *ngIf="isEditPage() && !isEditMode" class="custom-control-label"
                               for="commercialOptInDisabled">
                          <b> I'd like to receive emails for items about latency improvements, network upgrades, events
                            and
                            press releases </b>
                        </label>
                      </div>
                    </div>
                    <div *ngIf="isAddPage()" class="form-group">
                      <div class="custom-control custom-checkbox">
                        <input class="custom-control-input" formControlName="receiveConfirmationEmails"
                               id="receiveConfirmationEmails"
                               type="checkbox">
                        <label class="custom-control-label" for="receiveConfirmationEmails">
                          <b style="color: #007bff"> Send notification to the email address </b>
                        </label>
                      </div>
                    </div>

                    <hr *ngIf="isEditPage() || isShowPage()" class="user-form-card__divider">
                    <div *ngIf="isEditPage() || isShowPage()" class="form-group">
                      <label for="user_api_key_input">API key</label>
                      <div class="input-group">
                        <input class="form-control" formControlName="apiKey" id="user_api_key_input" readOnly type="text">
                        <div class="input-group-append">
                          <button (click)="regenerateApi(currentUser, $event)" *ngIf="currentCompany"
                                  [disabled]="isShowPage() || !isEditMode"
                                  class="btn btn-outline-primary"
                                  id="regenerate_user_api_key_button"
                                  type="button">
                            <i aria-hidden="true" class="fa fa-refresh pr-2"></i>
                            Regenerate
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <div class="col-lg-6 col-md-12 pr-2">
                <div *ngIf="canChangeSuperRole()" class="mb-3">
                  <button (click)="changeSuperRole()" *ngIf="currentCompany"
                          [disabled]="!enabledTransferSuperRoleButton"
                          class="btn btn-outline-primary" id="change_super_role_button"
                          type="button">
                    Transfer super role
                  </button>
                </div>
                <section
                  *ngIf="isAddPage() || isEditPage() || (hasGroup('admin', getUserCurrent()) || hasGroup('super', getUserCurrent()) || getUserCurrent()?.uniqid === currentUser?.uniqid)"
                  class="user-form-card">
                  <header class="user-form-card__header">
                    <span class="user-form-card__icon"><i class="fa fa-users"></i></span>
                    <span>Roles</span>
                    <span *ngIf="(isAddPage() || isEditPage()) && submitted && !hasRoles()"
                          class="alert required-items-alert mb-0 ml-2">
                      At least a role is required
                    </span>
                    <span *ngIf="isEditPage() && uniqRolesError" class="alert required-items-alert mb-0 ml-2">
                      At least one user must have role [{{ uniqRolesErrorsArrayString }}]
                    </span>
                  </header>
                  <div class="user-form-card__body">
                    <div
                      *ngIf="isAddPage() || isEditPage() && (hasGroup('admin', getUserCurrent()) || hasGroup('super', getUserCurrent()))">
                      <div *ngFor="let role of roleCheckBoxes" class="custom-control custom-checkbox mb-2">
                        <input *ngIf="isAddPage() || isEditPage() && isEditMode"
                               (click)="lastUserWithThisRole($event, role)"
                               [ngClass]="{ 'is-invalid': submitted && !hasRoles() || uniqRolesErrorsArray.includes(role.label)}"
                               class="custom-control-input"
                               formControlName="{{role.formControlName}}" id="{{role.id}}_enabled" type="checkbox">
                        <label *ngIf="isAddPage() || isEditPage() && isEditMode" class="custom-control-label"
                               for="{{role.id}}_enabled">
                          {{ role.label }}
                        </label>
                        <input *ngIf="isEditPage() && !isEditMode"
                               [ngClass]="{ 'is-invalid': (submitted && !hasRoles()) }"
                               class="custom-control-input" disabled
                               formControlName="{{role.formControlName}}" id="{{role.id}}_disabled"
                               type="checkbox">
                        <label *ngIf="isEditPage() && !isEditMode" class="custom-control-label"
                               for="{{role.id}}_disabled">
                          {{ role.label }}
                        </label>
                        <small *ngIf="!!role.helperBlockText" class="form-text text-muted info-text"
                               style="margin-top: -.25rem">
                          {{ role.helperBlockText }}
                        </small>
                        <div *ngIf="!isAddPage() && isClientUser() && role.label === 'finance'">
                          <span>{{ replaceEntitiesNames() }}</span><br>
                          <span><a
                            *ngIf="isClientUser() && (hasGroup('super', currentUser) || hasGroup('admin', currentUser)|| hasGroup('finance', currentUser))"
                            routerLink="/{{currentCompany?.uniqid}}/manage-inv-recipient">Manage invoice recipients</a></span>
                        </div>
                      </div>
                    </div>
                    <div
                      *ngIf="isShowPage() || isEditPage() && !(userHasOneOfThoseRoles(['ROLE_MCKAY_SUPER', 'ROLE_CLIENT_SUPER', 'ROLE_MCKAY_ADMIN', 'ROLE_CLIENT_ADMIN'], getUserCurrent()))">
                      <div *ngFor="let role of roles">
                        <div *ngIf="hasGroup(role.label, currentUser)">
                          <input class="form-control-plaintext" id="{{role.label}}" readonly type="text"
                                 value="{{role.label}}">
                          <small *ngIf="!!role.description" class="form-text text-muted info-text">
                            {{ role.description }}
                          </small>
                          <div *ngIf="role.label === 'finance'">
                            <span>{{ replaceEntitiesNames() }}</span><br>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>

                <ng-container *ngIf="!this.isNotificationOnlyForm.value">
                  <section
                    *ngIf="(isEditPage() && (hasGroup('dad_reporter', currentUser) || hasGroup('super', currentUser))) || (isAddPage() && dadReportingsCheckbox?.length > 0)"
                    class="user-form-card">
                    <header class="user-form-card__header">
                      <span class="user-form-card__icon"><i class="fa fa-bar-chart"></i></span>
                      <span>DAD Reporting</span>
                    </header>
                    <div class="user-form-card__body">
                      <div *ngFor="let dadReporting of dadReportingsCheckbox"
                           class="custom-control custom-checkbox custom-control-inline">
                        <input class="custom-control-input" formControlName="{{dadReporting.name}}"
                               id="{{dadReporting.name}}"
                               name="{{dadReporting.id}}" type="checkbox">
                        <label class="custom-control-label"
                               for="{{dadReporting.name}}">{{ dadReporting.name }}</label>
                      </div>
                    </div>
                  </section>
                </ng-container>

                <section *ngIf="isEditPage() && getUserCurrent()?.uniqid == currentUser?.uniqid" class="user-form-card">
                  <header class="user-form-card__header">
                    <span class="user-form-card__icon"><i class="fa fa-lock"></i></span>
                    <span>Security</span>
                  </header>
                  <div class="user-form-card__body">
                    <span *ngIf="submitted && passwordIsInvalid" class="alert required-items-alert">
                      This password is not secure. Try a different password.
                  </span>
                    <span *ngIf="submitted && !passwordIsInvalid && !validPassword()" class="alert">
                      The two passwords must be the same.
                  </span>
                    <div class="form-inline">
                      <div class="input-group col-3 justify-content-end text-right">
                        <b>New password</b>
                      </div>
                      <input [ngClass]="{ 'is-invalid error': submitted && !validPassword() }" [readOnly]="!isEditMode"
                             class="form-control col-9" formControlName="password"
                             id="new_password_input" name="password"
                             placeholder="password"
                             type="password"/>
                    </div>

                    <div class="form-inline mt-2">
                      <div class="input-group col-3 justify-content-end text-right">
                        <b>Confirm new password</b>
                      </div>
                      <div class="col-9 d-flex flex-column pr-0 pl-0">
                        <input [ngClass]="{ 'is-invalid error': submitted && !validPassword() }" [readOnly]="!isEditMode"
                               class="form-control"
                               formControlName="confirmPassword"
                               id="confirm_new_password_input" name="confirmPassword"
                               placeholder="confirm password"
                               type="password"/>
                      </div>
                    </div>

                    <div class="form-inline">
                      <div class="input-group col-3 justify-content-end text-right">
                      </div>
                      <div class="col-9 d-flex flex-column pr-0 pl-0">
                        <small class="form-text text-muted info-text">
                          Your password must be at least 8 characters long and contains at least one number and a special
                          character.
                          <br/>
                          If you would like to change the password type a new one. Otherwise leave this blank.
                        </small>
                      </div>
                    </div>
                    <app-password-strength (passwordStrength)="passwordValid($event)"
                                           [passwordToCheck]="passwordForm.value"
                                           style="text-align: center"></app-password-strength>
                  </div>
                </section>

                <section *ngIf="(isEditPage() || isShowPage()) && currentUser" class="user-form-card">
                  <header class="user-form-card__header">
                    <span class="user-form-card__icon"><i class="fa fa-history"></i></span>
                    <span>Activity</span>
                  </header>
                  <div class="user-form-card__body user-meta-footer">
                    <div class="user-meta-item">
                      <span class="user-meta-label">Created</span>
                      <span class="user-meta-value">{{ currentUser.createdAt ? (currentUser.createdAt | date:'MMM d, y H:mm') : '—' }}</span>
                    </div>
                    <div class="user-meta-item">
                      <span class="user-meta-label">Last updated</span>
                      <span class="user-meta-value">{{ currentUser.updatedAt ? (currentUser.updatedAt | date:'MMM d, y H:mm') : '—' }}</span>
                    </div>
                    <div class="user-meta-item">
                      <span class="user-meta-label">Last login</span>
                      <span class="user-meta-value">{{ currentUser.lastLogin ? (currentUser.lastLogin | date:'MMM d, y H:mm') : 'Never' }}</span>
                    </div>
                    <div class="user-meta-item">
                      <span class="user-meta-label">Last API call</span>
                      <span class="user-meta-value">{{ currentUser.lastApiCalled ? (currentUser.lastApiCalled | date:'MMM d, y H:mm') : 'Never' }}</span>
                    </div>
                    <div class="user-meta-item">
                      <span class="user-meta-label">Last failed login</span>
                      <span class="user-meta-value">{{ currentUser.lastFailedLoginAt ? (currentUser.lastFailedLoginAt | date:'MMM d, y H:mm') : 'None' }}</span>
                    </div>
                  </div>
                </section>
              </div>
            </div>

            <div class="d-flex justify-content-end user-form-footer">
              <button *ngIf="currentCompany" class="btn btn-outline-primary mr-2" id="back_to_list_users_button"
                      routerLink="/{{getUserCurrent()?.company.uniqid}}/{{currentCompany?.uniqid}}/users"
                      type="button">
                <i aria-hidden="true" class="fa fa-arrow-left pr-2"></i>
                Back to list
              </button>
              <button *ngIf="isAddPage()" [disabled]="registerForm.pristine || !hasBillingAccount()"
                      class="btn btn-outline-primary" id="add_user_button"
                      type="submit">
                <i aria-hidden="true" class="fa fa-plus-circle pr-2"></i>
                Add user
              </button>
              <div *ngIf="isShowPage() && currentCompany">
                <button *ngIf="canEditUser(currentUser)" class="btn btn-outline-primary" id="edit_user_button"
                        routerLink="/{{getUserCurrent()?.company.uniqid}}/{{currentCompany?.uniqid}}/{{currentUser?.uniqid}}/edit"
                        type="button">
                  <i aria-hidden="true" class="fa fa-edit pr-2"></i>
                  Edit
                </button>
              </div>
              <button *ngIf="isEditPage()" [disabled]="registerForm.pristine || !isEditMode || !hasBillingAccount()"
                      class="btn btn-outline-primary"
                      type="submit">Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </ng-template>

  <p-dialog *ngIf="!isUserToEditInSameCompanyAsLoggedInUser && isEditPage()" [(visible)]="unlockDialogDisplay"
            [modal]="true">
    <div *ngIf="invalidPasswordOnEditMode" class="alert alert-danger">Invalid password</div>
    <ng-template pTemplate="header">
      Enter password
    </ng-template>
    Please enter your password to edit this user information.
    <form (ngSubmit)="onSubmitUnlock()" [formGroup]="unlockForm">
      <div class="form-group">
        <label for="unlock_password_input">
          <span *ngIf="unlockPasswordForm.touched && unlockPasswordForm.errors" class="alert required-items-alert"> is required </span>
        </label>
        <div class="pl-2">
          <input [ngClass]="{ 'is-invalid': unlockPasswordForm.touched && unlockPasswordForm.errors }"
                 class="form-control" formControlName="password" id="unlock_password_input"
                 placeholder="Password"
                 type="password">
        </div>
      </div>
      <div class="d-flex justify-content-end buttons-margin-left mt-3">
        <button (click)="hideUnlockDialog()" class="btn btn-outline-primary" id="cancel_unlock_form_button"
                type="button">
          <i aria-hidden="true" class="fa fa-close pr-2"></i>
          Cancel
        </button>
        <button [disabled]="unlockForm.invalid" class="btn btn-outline-primary ml-3" id="unlock_form_button"
                type="submit">
          <i aria-hidden="true" class="fa fa-unlock pr-2"></i>
          Unlock
        </button>
      </div>
    </form>
  </p-dialog>
  <p-dialog *ngIf="isFinanceUserSelected && isAddPage()" [(visible)]="isFinanceUserSelected" [modal]="true">
    <ng-template pTemplate="header">
      Manage invoice Recipients
    </ng-template>
    <div class="col-12 alert alert-primary">
      <strong>We will send this new user invoices relative to the checked Mckay entities/Region.
        Please deselect the McKay entities from which this user does not need to receive invoices.</strong><br>
    </div>
    <div class="col-12">
      <div class="mckay-entities-checkboxes">
        <div *ngFor="let entity of mckayEntities">
          <p-checkbox [(ngModel)]="entity.checked" binary="true" label="{{entity.label}}"></p-checkbox>
        </div>
        <div class="display-right">
          <button (click)="saveMckayEntities()" class="btn btn-outline-success mr-1 custom-button">
            <i aria-hidden="true" class="fa fa-check-circle pr-2"></i>Validate
          </button>
        </div>
      </div>
    </div>
  </p-dialog>
</div>
